import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Vehicles</h3>
                <p className="text-sm text-gray-600">
                    Add, view, and manage your fleet of vehicles here.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Adding Vehicles</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click the <strong>Add Vehicle</strong> button to register a new vehicle.</li>
                    <li>Fill in the required information such as Name, License Plate, Make, Model, etc.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Browsing and Searching</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Search Bar</strong> to find vehicles by name or license plate.</li>
                    <li>The list displays key details including status and type.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Exporting Data</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select specific vehicles using the checkboxes in the table to export them.</li>
                    <li>You can export the selected vehicle data to <strong>PDF</strong> or <strong>CSV</strong> formats.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
